import React from 'react';
import withSpacingStyles from './withSpacingStyles';

export default function withStyleSystem<T extends React.ComponentType<React.ComponentProps<T>>>(Component: T) {
  return withSpacingStyles(Component);
}
